<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Merchants</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="searchColumn"
              :items="filteredSearchColumn"
              item-text="text"
              item-value="value"
              label="Select column"
              return-object
              single-line
              hide-details
              class="mr-3"
              @input="customSearch"
            ></v-select>
            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Search..."
              single-line
              hide-details
              @input="customSearch"
            ></v-text-field>
            <v-spacer v-if="loggedUser.role === '1'"></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click.stop="rightDrawer = !rightDrawer"
            >New Merchant</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :options.sync="options"
              :server-items-length="totalData"
              :loading="loading"
              class="elevation-1"
              :must-sort="true"
              :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
              :items-per-page="15"
            >
              <template v-slot:item.status_name="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status_name }}</v-chip>
              </template>
              <template v-slot:item.name="{ item }">
                <a @click="goToMerchant(item)" dark>{{ item.name }}</a>
              </template>
              <template v-slot:item.campaigns="{ item }">
                
                <div v-for="(campaign, index) in item.campaigns" :key="index" class="campaign-list">
                  <div class="body-2">{{campaign.name}}</div>
                  <v-divider v-if="index !== item.campaigns.length -1"></v-divider>
                </div>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="$router.push({ path: 'merchants/' + item.id, params: { clientId: item.id } })"
                >mdi-square-edit-outline</v-icon>
                <v-icon small @click="deleteMerchant(item.id)">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
        <v-navigation-drawer absolute right width="50%" v-model="rightDrawer">
          <v-flex md12 sm12 lg12>
            <h1>{{merchantDetails.formTitle}}</h1>
            <v-form ref="newMerchant" v-model="formValid">
              <v-form-base
                v-bind:value="merchantDetails.data.merchant"
                v-bind:schema="newMerchantSchema.merchant"
              />
              <h2>Legal Representative</h2>
              <v-form-base
                v-bind:value="merchantDetails.data.contacts.rappresentante"
                v-bind:schema="newMerchantSchema.contacts.rappresentante"
              />
              <h2>Tecnical Contact</h2>
              <v-form-base
                v-bind:value="merchantDetails.data.contacts.referente"
                v-bind:schema="newMerchantSchema.contacts.referente"
              />
            </v-form>
            <v-btn
              color="primary"
              @click="addMerchant(merchantDetails.data)"
            >Create Merchant</v-btn>
            <v-btn color="secondary" outlined @click="resetForm(), rightDrawer = false">Cancel</v-btn>
          </v-flex>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '../services'
import { mapState } from 'vuex'
import VFormBase from 'vuetify-form-base'
import formRules from '@/mixins'

export default {
  components: { VFormBase },
  watch: {
    options: {
      handler () {
        this.getMerchants()
      },
      deep: true
    },
    dialog (val) {
      val || this.closeModal()
    }
  },
  mixins: [formRules],
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter((item) => item.value !== 'action')
    },
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas', 'relations']),
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    newMerchantSchema () {
      let clientsList = this.clientsList

      let clientRelationshipList = this.relations
      return {
        merchant: {
          name: {
            type: 'text',
            label: 'Name *',
            flex: 12,
            rules: [this.validationRules.requiredField('Name')]
          },
          description: {
            type: 'textarea',
            label: 'Description',
            maxlength: 1500,
            counter: 1500,
            flex: 12
          },
          client: {
            type: 'select',
            label: 'Client *',
            clearable: false,
            items: clientsList,
            itemValue: 'id',
            itemText: 'name',
            flex: { xs: 12, sm: 6 },
            rules: [v => !!v || 'Client is required']
          },
          relation: {
            type: 'select',
            label: 'Client Relationship *',
            clearable: false,
            items: clientRelationshipList,
            returnObject: false,
            itemValue: 'id',
            itemText: 'relation_name',
            rules: [v => !!v || 'Client Relationship is required'],
            flex: { xs: 12, sm: 6 }
          },
          vat_number: {
            type: 'text',
            label: 'Vat Number *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            rules: [
              this.validationRules.requiredField('Vat Number'),
              this.validationRules.requiredlength('Vat Number', 11)
            ]
          },
          address: {
            type: 'text',
            label: 'Address *',
            flex: 12,
            rules: [this.validationRules.requiredField('Address')]
          },
          zip_code: {
            type: 'text',
            label: 'Zip Code *',
            mask: '############',
            maxlength: 5,
            flex: 6,
            rules: [
              this.validationRules.requiredField('Zip Code'),
              this.validationRules.requiredlength('Zip Code', 5)
            ]
          },
          city: {
            type: 'text',
            label: 'City *',
            flex: 4,
            rules: [this.validationRules.requiredField('City')]
          },
          province: {
            type: 'text',
            label: 'Province *',
            flex: 2,
            rules: [this.validationRules.requiredField('Province')]
          },
          fiscal_code: {
            type: 'text',
            label: 'Fiscal Code',
            flex: 12,
            counter: 11,
            rules: [
              this.validationRules.requiredlength('Fiscal Code', 11)
            ]
          },
          ateco_code: {
            type: 'text',
            label: 'Ateco Code',
            flex: 12
          },
          iban: {
            type: 'text',
            label: 'IBAN',
            flex: 12,
            counter: 27,
            maxlength: 27,
            rules: [
              this.validationRules.requiredlength('Iban', 27)
            ]
            
          },
          website: {
            type: 'text',
            label: 'Website',
            flex: 12
          }
        },
        contacts: {
          referente: {
            first_name: {
              type: 'text',
              label: 'First name *',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone *',
              flex: 6,
              rules: [this.validationRules.requiredField('Phone')]
            }
          },
          rappresentante: {
            first_name: {
              type: 'text',
              label: 'First name *',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone *',
              flex: 6,
              rules: [this.validationRules.requiredField('Phone')]
            }
          }
        }
      }
    }
  },
  data () {
    return {
      // Ricerca nella tabella
      searchColumn: '',
      tableSearch: '',
      tableSearchTimeout: false,

      // Lists
      clientsList: [],

      // Tabella Npo
      tableHeaders: [
        {
          text: 'Merchant',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Client',
          align: 'left',
          sortable: true,
          value: 'client_name'
        },
        {
          text: 'Client relationship',
          align: 'left',
          sortable: true,
          value: 'relation_name'
        },
        { text: 'Status',
          value: 'status_name'
        },
        {
          text: 'Campaigns',
          align: 'left',
          sortable: true,
          value: 'campaigns'
        },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      options: {},
      totalData: 0,
      tableData: [],
      loading: true,

      /**
       * New Merchant form
       */
      rightDrawer: false,
      formValid: true,
      merchantDetails: {
        formTitle: 'New Merchant',
        data: {
          merchant: {
            name: null
          },
          contacts: {
            rappresentante: {
              first_name: null
            },
            referente: {
              first_name: null
            }
          },
          user: {
            password: null
          }
        }
      }
    }
  },

  mounted () {
    // this.getMerchants()
    this.getClientsList()
  },

  methods: {
    // GET Clients
    getMerchants () {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      // Setup search filter extending data-table componet option object
      // TO DO refactoring to use component and props (check if possible)
      let filter = {}
      filter.orderBy = sortBy[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.orderDesc = sortDesc[0] || null

      filter.search_filter = this.tableSearch !== '' ? this.searchColumn.value : ''
      filter.search_value = this.tableSearch || ''

      // GET on global entities search API endpoint
      apiService
        .fetchData('merchants', filter)
        .then((data) => {
          setTimeout(() => {
            this.tableData = data
            this.totalData = data.lenght
            this.loading = false
          }, 800)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `${error.data.message}`
          })
        })
    },

    // This will trigger when either of the search inputs is changed
    customSearch () {
      if (this.searchColumn !== '') {
        // Stop timeout to prevent search from firing while user is still typing
        clearTimeout(this.tableSearchTimeout)
        // Set a timeout to fire search after the user has stopped typing
        this.tableSearchTimeout = setTimeout(() => {
          this.getMerchants()
        }, 800)
      }
    },

    /**
     * Lists
     */
    getClientsList () {
      apiService
        .getClientsList()
        .then((response) => {
          this.clientsList = response
          this.dataLoaded = !this.dataLoaded
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `${error}`
          })
        })
    },

    // Validate and submit form
    validateForm () {
      return this.$refs.newMerchant.validate()
    },

    resetForm () {
      console.log('reset')
      this.$refs.newMerchant.reset()
    },

    addMerchant () {
      if (this.validateForm()) {
        let newMerchantData = this.merchantDetails.data.merchant
        newMerchantData.status = 1

        // GET on global entities search API endpoint
        apiService
          .newMerchant(newMerchantData)
          .then(response => {
            this.rightDrawer = false

            // Create merchant contacts
            this.merchantDetails.data.contacts.referente.is_tech_rep = true
            apiService
              .createContact('merchants', response.id, this.merchantDetails.data.contacts.referente)
              .then(response => {
                console.log(response)
              })
              .catch(error => {
                console.log(error)
              })

            this.merchantDetails.data.contacts.rappresentante.is_legal_rep = true
            apiService
              .createContact('merchants', response.id, this.merchantDetails.data.contacts.rappresentante)
              .then(response => {
                console.log(response)
              })
              .catch(error => {
                console.log(error)
              })
            // Fetch merchants
            this.getMerchants()
          })
          .catch((error) => {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `${error.message}`
            })
          })
      } 
    },

    deleteMerchant (merchantId) {
      apiService
        .deleteMerchant(merchantId)
        .then((response) => {
          console.log(response)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Merchant succesfully deleted`
          })
          this.getMerchants()
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot delete Merchant`
          })
        })
    },

    goToMerchant (item) {
      this.$router.push({
        path: 'merchants/' + item.id,
        params: { id: item.id }
      })
    },

    // Setup mock of statuses color since definitive set of statuses has not been provided yet
    // TO DO save statuses and properties in store - Riccardo Cosentino 04052020
    getStatusColor (status) {
      if (status === 1 || status === '1' || status === true) return 'green'
      else if (status === 2 || status === '2' || status === false) return 'red'
      else return 'gray'
    }
  }
}
</script>
